export const ALLOWED_IMAGE_TYPES = ['image/jpeg', 'image/png', 'image/webp'];
export const ALLOWED_IMAGE_ACCEPT = '.jpg,.jpeg,.png,.webp';
export const MAX_IMAGE_SIZE = 2 * 1024 * 1024; // 2 МБ

// Синхронная валидация типа и размера
// Возвращает { valid: true } или { valid: false, error: '...' }
export function validateImageFile(file) {
    if (!ALLOWED_IMAGE_TYPES.includes(file.type)) {
        return { valid: false, error: 'Допустимые форматы: JPEG, PNG, WebP' };
    }
    if (file.size > MAX_IMAGE_SIZE) {
        return { valid: false, error: 'Размер фото должен быть не более 2 МБ' };
    }
    return { valid: true };
}

// Асинхронная валидация разрешения через FileReader + Image
// Возвращает { valid: true } или { valid: false, error: '...' }
export async function validateImageDimensions(file, maxDimension) {
    return new Promise((resolve) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = (e) => {
            const img = new Image();
            img.src = e.target.result;
            img.onload = function () {
                if (this.width > maxDimension || this.height > maxDimension) {
                    resolve({ valid: false, error: `Стороны изображения должны быть не более ${maxDimension}px` });
                } else {
                    resolve({ valid: true });
                }
            };
        };
    });
}
